/* ============
 * Actions for the auth module
 * ============
 *
 * The actions that are available on the
 * auth module.
 */

import Vue from 'vue'
import decode from 'jwt-decode'

import store from '@/app/store'
import * as types from './mutation-types'

import {
  AUTH_SESSION_COOKIE_TTL,
  CHECK_SESSION_INTERVAL,
  RENEW_TOKEN_BEFORE
} from '../../../plugins/auth'

let checkSessionIntervalId = null

const createSessionTimer = dispatch => {
  removeSessionTimer()
  checkSessionIntervalId = window.setInterval(() => {
    dispatch('auth/check')
  }, CHECK_SESSION_INTERVAL)
}

const removeSessionTimer = () => {
  if (checkSessionIntervalId) {
    window.clearInterval(checkSessionIntervalId)
  }
}

export async function check ({rootState, commit}) {
  // check session
  const session = Vue.$auth.getUserSession()

  if (!session.idToken) {
    return
  }
  createSessionTimer(store.dispatch)

  // check token expiration
  // Check if we need to renew token
  const now = new Date().getTime()

  if (now > session.expiresAt - RENEW_TOKEN_BEFORE) {
    await store.dispatch('auth/renew')
  } else {
    commit(types.SET_PERMISSIONS, ['admin', 'any'])
    // page was reload - get user info from API
    if (!rootState.account.id) {
      // get user from session
      commit(types.LOGIN, session)
      await store.dispatch('account/find')
    }
  }
}

export async function renew ({rootState, commit}) {
  try {
    const response = await Vue.$auth.renew()
    const newExpiresAt = new Date(
      new Date().getTime() + AUTH_SESSION_COOKIE_TTL
    )
    Vue.$auth.createSession(response.idToken, newExpiresAt)

    commit(types.LOGIN, {idToken: response.idToken, expiresAt: newExpiresAt})
    commit(types.SET_PERMISSIONS, ['admin', 'any'])

    if (!rootState.account.id) {
      await store.dispatch('account/find')
    }
  } catch (e) {
    console.error('[RENEW ERROR]', e)

    store.dispatch('auth/logout')
  }
}

export async function login ({commit}) {
  try {
    const response = await Vue.$auth.authenticate()
    const token = decode(response.idToken)
    const exp = token.exp * 1000
    const data = {
      idToken: response.idToken,
      expiresAt: exp,
      userInfo: token
    }
    Vue.$auth.createSession(response.idToken, new Date(exp))
    commit(types.LOGIN, data)
    commit(types.SET_PERMISSIONS, ['admin', 'any'])
    Vue.$http.defaults.headers.common.Authorization = `Bearer ${response.idToken}`
    Vue.router.replace({
      name: 'start.index'
    })
  } catch (e) {
    console.error('[LOGIN ERROR]', e)

    Vue.router.replace({
      name: 'start.index'
    })
  }
}

export const logout = ({commit}) => {
  commit(types.LOGOUT)
  Vue.$auth.clearSession()
  store.dispatch('account/reset')
  Vue.$auth.logout()
}

export default {
  check,
  renew,
  login,
  logout
}



// WEBPACK FOOTER //
// ./src/app/store/modules/auth/actions.js